import React from 'react';
import { graphql } from "react-apollo";

import { comment } from '../../graphql/queries';
import { ColError, ColLoading } from '../chunk';
import { Comment, CommentList }  from "./index";
import { PostAdd }  from "../post";

class CommentDetail extends React.Component {
	render() {

		let { loading, error, comment, comments } = this.props.data;

		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
		if( error ) return (<div className="col col-2"><ColError error={error} /></div>)
		console.log(comments);

		return (
			<div key={comment.id} className="col col-2">

						<div className="commentDetail">
		        	<Comment votes={comment.votes} key={comment.id} id={comment.id} message={comment.body} user={comment.user} date={comment.dateCreated} />
						</div>
		        
				<PostAdd channel={comment.parent} reply={comment.id} />
				<CommentList comments={comments} />
			</div>
      	)
	}
}

const queryOptions = {
  options: props => ({
    variables: { id: props.match.params.id_2 }
  })
}


export default  graphql(comment, queryOptions)(CommentDetail)


// WEBPACK FOOTER //
// ./src/components/comment/CommentDetail.js